// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-recent-matches-filter__list__title{
    padding: 12px 24px;
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.profile-recent-matches-filter__list__title.baloa-table{
    color: var(--primary-very-dark-color);
}

.profile-recent-matches-filter__list__title .hubicon-clear_option {
    font-size: 14px;
    cursor: pointer;
}

.profile-recent-matches-filter__list-button.MuiButton-text{
    padding: 8px 12px;
    border: 1px solid var(--new-gray-color);
    border-radius: 5px;
}

.profile-recent-matches-filter__list-button .baloa-table{
    color: var(--black-color);
    display: flex;
    align-items: center;
    text-transform: none;
}

.profile-recent-matches-filter__list-button .hubicon-expand_more{
    font-size: 20px;
    margin-left: 16px;
}

.profile-recent-matches-filter__buttons{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 24px;
    border-top: 1px solid var(--new-gray-background-color);
}

.profile-recent-matches-filter__list .MuiList-padding{
    padding: 0;
}

.profile-recent-matches-filter__list .MuiPaper-root{
    width: 370px;
}

.profile-recent-matches-filter__button-cancel{
    margin-right: 12px;
}


.profile-recent-matches-filter__radio-group .MuiRadio-root{
    color: var(--new-gray-color);
}

.profile-recent-matches-filter__radio-group.MuiFormControl-root{
    width: 100%;
}

.profile-recent-matches-filter__radio-group .MuiFormControlLabel-labelPlacementStart{
    justify-content: space-between;
    margin-right: 0;
}

.profile-recent-matches-filter__radio-group .MuiTypography-body1 .baloa-table-column{
    color: var(--primary-very-dark-color);
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-recent-matches-filter/ProfileRecentMatchesFilter.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".profile-recent-matches-filter__list__title{\n    padding: 12px 24px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.profile-recent-matches-filter__list__title.baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.profile-recent-matches-filter__list__title .hubicon-clear_option {\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.profile-recent-matches-filter__list-button.MuiButton-text{\n    padding: 8px 12px;\n    border: 1px solid var(--new-gray-color);\n    border-radius: 5px;\n}\n\n.profile-recent-matches-filter__list-button .baloa-table{\n    color: var(--black-color);\n    display: flex;\n    align-items: center;\n    text-transform: none;\n}\n\n.profile-recent-matches-filter__list-button .hubicon-expand_more{\n    font-size: 20px;\n    margin-left: 16px;\n}\n\n.profile-recent-matches-filter__buttons{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 12px 24px;\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.profile-recent-matches-filter__list .MuiList-padding{\n    padding: 0;\n}\n\n.profile-recent-matches-filter__list .MuiPaper-root{\n    width: 370px;\n}\n\n.profile-recent-matches-filter__button-cancel{\n    margin-right: 12px;\n}\n\n\n.profile-recent-matches-filter__radio-group .MuiRadio-root{\n    color: var(--new-gray-color);\n}\n\n.profile-recent-matches-filter__radio-group.MuiFormControl-root{\n    width: 100%;\n}\n\n.profile-recent-matches-filter__radio-group .MuiFormControlLabel-labelPlacementStart{\n    justify-content: space-between;\n    margin-right: 0;\n}\n\n.profile-recent-matches-filter__radio-group .MuiTypography-body1 .baloa-table-column{\n    color: var(--primary-very-dark-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
